import { useRemoteConfig } from '@funtech-int/yango-shared';

export type BenefitType = 'family' | 'watch' | 'download' | 'taxi' | 'vibe';

type OnboardingConfig = {
    isInfoBlocksSectionEnabled: boolean;
    isChannelsInfoBlockEnabled: boolean;
    isMusicLandingNavigationEnabled: boolean;
    isYasminaLandingNavigationEnabled: boolean;
    isYasminaInfoBlockEnabled: boolean;
    benefitsInfoBlock: BenefitType[];
};

export function useYangoOnboardingConfig() {
    const remoteConfig = useRemoteConfig();

    return remoteConfig.flags.get('onboarding_config') as OnboardingConfig | undefined;
}
